// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8 15.2496V14.0002L8.75003 14.0001V15.2494L8 15.2496Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.5 14.0005L14.25 14.0003V17.9999L13.5 18.0003V14.0005Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H21V17.2497H19V20.0002H17V13.5006C17 12.6724 17.6713 12.0008 18.4996 12.0006L20.9998 12L21 12.8889V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM9.25031 17.2493L8 17.2496V20.0003H6V12.0004L9.24988 12C10.0784 12 10.75 12.6716 10.75 13.5V15.7493C10.75 16.5777 10.0786 17.2492 9.25031 17.2493ZM16.25 13.5001V18.4997C16.25 19.3279 15.5789 19.9993 14.7507 19.9997L11.5 20.0012V12.001L14.7496 12.0001C15.5782 11.9999 16.25 12.6716 16.25 13.5001Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 14L19 14.0005V15.2497H21V14Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-pdf-filled')
export default class FilePdfFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-pdf-filled',
    }
  }
}
